var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServernetworkIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H35.9883C42.6157 0 47.9883 5.37258 47.9883 12V35.9883C47.9883 42.6157 42.6157 47.9883 35.9883 47.9883H12C5.37258 47.9883 0 42.6157 0 35.9883V12Z",
    fill: "#E8F4FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9893 14.0007H15.9997C14.8958 14.0007 14.001 14.8955 14.001 15.9994V19.9968C14.001 21.1006 14.8958 21.9955 15.9997 21.9955H31.9893C33.0931 21.9955 33.988 21.1006 33.988 19.9968V15.9994C33.988 14.8955 33.0931 14.0007 31.9893 14.0007Z",
    stroke: "#057DCD",
    strokeWidth: 1.9987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9893 25.9929H15.9997C14.8958 25.9929 14.001 26.8877 14.001 27.9916V31.989C14.001 33.0928 14.8958 33.9877 15.9997 33.9877H31.9893C33.0931 33.9877 33.988 33.0928 33.988 31.989V27.9916C33.988 26.8877 33.0931 25.9929 31.9893 25.9929Z",
    stroke: "#057DCD",
    strokeWidth: 1.9987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.998 17.998H18.008",
    stroke: "#057DCD",
    strokeWidth: 1.9987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.998 29.9902H18.008",
    stroke: "#057DCD",
    strokeWidth: 1.9987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServernetworkIcon);
export default __webpack_public_path__ + "static/media/servernetwork-icon.b947a9aeb10dacfded5e8d6aa6728565.svg";
export { ForwardRef as ReactComponent };